// @ts-check

import * as op from 'rxjs/operators';
import { SystemStatus } from "./system-status.module";


// export type Constructor = (
//   $scope: TillerAppController.IScope,
//   UserService: UserService,
//   ProviderAccountsService: ProviderAccountsService,
//   SheetsService: SheetsService,
//   OBQService: OBQService,
//   FEATURES: FeatureFlags,
//   $intercom,
//   $analytics,
//   $timeout,
//   $interval,
//   $uibModal,
//   MAINTENANCE,
//   $location: ng.ILocationService,
// ) => void;

export default [
  '$scope',
  'UserService',
  'ProviderAccountsService',
  'SheetsService',
  'SystemStatusService',
  'StatusPageService',
  'OBQService',
  'ConversionService',
  'FEATURES',
  '$intercom',
  '$analytics',
  '$timeout',
  '$interval',
  '$uibModal',
  'MAINTENANCE',
  '$location',
  TillerAppController
];

/**
 * @constructor
 * @param {TillerAppController$Scope} $scope
 * @param {import('core-services/user.service').UserService} UserService
 * @param {import("core-services/provider-accounts.service").ProviderAccountsService} ProviderAccountsService
 * @param {import("core-services/sheets.service").SheetsService} SheetsService
 * @param {import("./system-status.module").SystemStatusService} SystemStatusService
 * @param {import("./status-page/status-page.module").IStatusPageService} StatusPageService
 * @param {import("./conversion.service").ConversionService} ConversionService
 * @param {import("../app/obq/obq.service").OBQService} OBQService
 */
export function TillerAppController(
  $scope,
  UserService,
  ProviderAccountsService,
  SheetsService,
  SystemStatusService,
  StatusPageService,
  OBQService,
  ConversionService,
  FEATURES,
  $intercom,
  $analytics,
  $timeout,
  $interval,
  $uibModal,
  MAINTENANCE,
  $location,
) {
  $scope.ui = {
    showApplicationBody: true,
    showServiceAlert: false,
  };
  function updateUIFlags() {
    $scope.ui.showApplicationBody = ($scope.systemStatus !== 'initializing');
    $scope.ui.showServiceAlert = $scope.systemStatus == 'offline';
  }

  let hasAccounts = false;

  $scope.appData = {
    loggedIn: false,
    user: null,
  };

  SystemStatusService.status
    .subscribe(_ => {
      $scope.systemStatus = _;
      updateUIFlags();
    });

  $scope.currentYear = new Date().getFullYear();

  $scope.encodedAbsLocationUrl = encodeURIComponent($location.absUrl());

  $analytics.pageTrack('/');

  $scope.isAuthenticated = false;
  $scope.accountInfo = {
    displayName: 'unknown',
    email: 'unknown',
    avatarUrl: "/assets/images/no-avatar@2x.png",
  };

  function checkForOBQPopup() {
    if ($scope.showOnboardingQuestionsView() && !OBQService.isOpen) {
      return OBQService.openModal()
        .then(function(result) {
          return UserService.updateOBQAnswers(result);
        });
    }
  }

  let isOnboarding = false;
  function setIsOnboarding(user) {
    isOnboarding = (user &&
    (user.lifetimeSheetsCreated == 0 &&
      (!user.sheetIds || user.sheetIds.length == 0)));
  }
  $scope.didOnboardThisSession = false;

  /// MARK: ViewModels ///

  /** @type {TillerAppController.OnboardingStep[]} */
  var OnboardingSteps = [
    { number: 1,
      percentage: 20,
      format: 'interstitial',
      message: "Step 1 of 3: Start your free trial. To start your 30 day free trial, add a payment method below. Subscriptions are $59 per year and you can easily cancel any time." },

    { number: 2,
      percentage: 50,
      format: 'console',
      message: "Step 2 of 3: Add Accounts. Link your primary checking or credit card account to Tiller to set up your daily automated data import." },

    { number: 3,
      percentage: 75,
      format: 'console',
      message: "Step 3 of 3: Create a new Tiller Sheet. We'll add your bank transactions and balances automatically each day. We have helpful and easy templates to get you started." },

    { number: 4,
      percentage: 100,
      format: 'console',
      message: "You're all set! Your data will be ready in a few moments.",
      detailMessages: [
        'You can create up to five Tiller Sheets. Just click "New Tiller Sheet" to create another one.'
      ]}
  ];

  $scope.shouldShowOnboardingFormat = function(format) {
    var step = $scope.onboardingStep();

    return !!step && step.format == format;
  };

  $scope.onboardingProgressStyle = function() {
    return {
      width: $scope.onboardingStep().percentage + "%",
    };
  };

  /**
   * Returns a ViewModel object based on the onboarding step the user is
   * currently on. Returns null if the user is not currently onboarding.
   *
   * This is used in the view to display information.
   */
  $scope.onboardingStep = function() {
    if ($scope.didOnboardThisSession == true) {
      return OnboardingSteps[3];
    }

    if (isOnboarding) {
      if (!hasCurrentSubscription()) {
        return OnboardingSteps[0];
      } else if (!hasAccounts) {
        return OnboardingSteps[1];
      } else {
        return OnboardingSteps[2];
      }
    }

    return null;
  };

  /// END ViewModels ///

  /// MARK: Subscription State Alert ///

  $scope.showSubscriptionAlert = function() {
    return UserService.inAnyState(['past_due', 'expired', 'canceled']);
  };

  $scope.userStateDescription = function() {
    if ($scope.appData.user?.state == "past_due" ) {
      return "is past due";
    } else if ($scope.appData.user?.state == "expired" ) {
      return "has expired"
    } else if ($scope.appData.user?.state == "canceled" ) {
      return "has been canceled"
    }

    return null;
  };

  /// END Subscription State Alert ///

  $scope.showSheetsView = function() {
    return UserService.inAnyState(['setup'])
      || (UserService.inAnyState(['trialing', 'active', 'past_due']) && hasAccounts);
  }
  $scope.showAccountsView = function() {
    return UserService.inAnyState(['setup', 'trialing', 'active', 'past_due']);
  }
  $scope.showPreferencesView = function() {
    return (UserService.inAnyState(['trialing', 'active', 'past_due']) && hasAccounts);
  }

  $scope.showSubscriptionView = false;

  $scope.showOnboardingQuestionsView = function() {
    console.log("showOnboardingQuestionsView -> ", FEATURES.obqQuestions, hasAccounts, hasLinkedSheets(), OBQService.hasAnswers);
    if (!FEATURES.obqQuestions) return false;
    if (!UserService.isAuthenticated$) return false;

    return hasAccounts && !hasLinkedSheets() && !OBQService.hasAnswers;
  }

  function hasLinkedSheets() {
    if (!$scope.appData.user?.sheetIds) return false;

    return $scope.appData.user?.sheetIds.length > 0;
  }

  function hasCurrentSubscription() {
    return $scope.appData.user?.subscription && UserService.inAnyState(['trialing', 'active', 'past_due']);
  }

  $scope.logout = function() {
    $intercom.shutdown();
    $scope.isAuthenticated = false;

    return;
  }

  // TODO(bls): This seems pointlessly complex.
  var DEFAULT_NAME = 'Tiller User';
  function getDisplayName(user) {
    if (!user) return DEFAULT_NAME;

    if (!user.profile || !user.profile.name) {
      if (!user.email) return DEFAULT_NAME;
      return user.email;
    }
    return user.profile.name;
  }

  function bootIntercom() {
    var intercomSettings = {};

    $intercom.boot(intercomSettings);
  }

  function updateIntercom(user) {
    var intercomSettings = {
      name: $scope.appData.displayName,
    };

    if(user) {
      intercomSettings.email = user.email;
      intercomSettings.user_id = user._id;
      intercomSettings.session_duration = 3600000; /* 1 hour */
      if(user.intercom) {
        intercomSettings.user_hash = user.intercom.user_hash;
      }
    }

    if (intercomSettings == null) {
      $intercom.update();
    } else {
      $intercom.update(intercomSettings)
    }

  }

  // REFACTOR: Should be a part of a UserDataService or something.
  $scope.handleSubscriptionChanged = function() {
    return UserService.fetchUser();
  };

  bootIntercom();
  $interval(function() {
    $intercom.update({ session_duration: 3600000 });
  }, 1800000);

  if (MAINTENANCE) {
    $uibModal.open({
      templateUrl: 'MaintenanceModalContent.html',
      controller: 'ModalInstanceCtrl',
      scope: $scope
    });
  } else {
    UserService
      .fetchUser()
      .then(function() {
        ProviderAccountsService.pollAccounts();
      });
  }

  SystemStatusService.status
    .subscribe(value => {
      console.log("System Status Changed: ", value);
      $scope.systemStatus = value;
    });

  SystemStatusService.status
    .pipe(
      op.filter(_ => _ == SystemStatus.Offline),
      op.take(1),
    ).subscribe(_ => {
      StatusPageService.getIncidents()
        .then(status => {
          console.log("INCIDENTS RETRIEVED: ", status);
        });
    });

  UserService.user$.subscribe(user => {
    $scope.appData.user = user;
    $scope.appData.displayName = getDisplayName(user);
    setIsOnboarding(user);
    // 2 second delay to allow Intercom back end to catch up
    $timeout($intercom.update, 2000);
    updateIntercom(user);

    if (!!user) {
      $scope.appData.loggedIn = true;
      $scope.isAuthenticated  = true;

      $scope.accountInfo = {
        displayName: $scope.appData.displayName,
        email: user.email,
        avatarUrl: user.profile.picture || "/assets/images/no-avatar@2x.png",
      };

      $analytics.setUsername(user.id);

      ConversionService.registerConversionIfNeeded();
      OBQService.setUser(user);
      $scope.showSubscriptionView = true;
    } else {
      $scope.appData.loggedIn = false;
      $scope.isAuthenticated  = false;

      $scope.accountInfo = {
        displayName: "unknown",
        email: "unknown",
        avatarUrl: "/assets/images/no-avatar@2x.png",
      };
      $scope.showSubscriptionView = false;
    }

    $scope.$applyAsync();
  });

  ProviderAccountsService
    .providerAccounts$
    .pipe(
      op.tap(_ => {
        hasAccounts = _.length > 0;
      }),
      op.filter(_ => _.length > 0),
    )
    .subscribe(_ => checkForOBQPopup());

  SheetsService
    .pendingSheets$
    .subscribe(pendingSheets => {
      if ($scope.didOnboardThisSession == false
          && isOnboarding
          && pendingSheets.length > 0) {

        $scope.didOnboardThisSession = true;
      }
    });
};

/**
 * @typedef {object} TillerAppController.IAppData
 * @property {boolean} loggedIn
 * @property {any} [user]
 * @property {string} [displayName]
 * @property {any[]} [sheets]
 */

/**
 * @typedef {object} TillerAppController.AccountInfo
 * @property {string} displayName
 * @property {string} email
 * @property {string} avatarUrl
 */

/**
 * @typedef {object} TillerAppController.OnboardingStep
 * @property {number} number
 * @property {number} percentage
 * @property {string} message
 * @property {'console' | 'interstitial'} format
 * @property {string[]} [detailMessages]
 */

/**
 * @typedef {object} TillerAppController.UIFlags
 * @property {boolean} showApplicationBody
 * @property {boolean} showServiceAlert
 */

/**
 * @typedef {object} TillerAppController.ScopeOnboarding
 * @property {() => object} onboardingProgressStyle
 * @property {(format:string) => boolean} shouldShowOnboardingFormat
 * @property {() => TillerAppController.OnboardingStep | null} onboardingStep
 */

/**
 * @typedef {object} TillerAppController.MyScope
 * @property {boolean} showSubscriptionView
 * @property {TillerAppController.UIFlags} ui
 * @property {string} systemStatus
 * @property {number} currentYear
 * @property {string} encodedAbsLocationUrl
 * @property {TillerAppController.AccountInfo} accountInfo
 * @property {boolean} didOnboardThisSession
 * @property {TillerAppController.IAppData} appData
 * @property {boolean} isAuthenticated
 * @property {() => boolean} showSubscriptionAlert
 * @property {() => string | null} userStateDescription
 * @property {() => boolean} showSheetsView
 * @property {() => boolean} showAccountsView
 * @property {() => boolean} showPreferencesView
 * @property {() => boolean} showOnboardingQuestionsView
 * @property {() => void} logout
 * @property {() => void} handleSubscriptionChanged
 */

/**
 * @typedef {TillerAppController.MyScope & TillerAppController.ScopeOnboarding & ng.IScope} TillerAppController$Scope
 */
